import { render, staticRenderFns } from "./CircleIcon.vue?vue&type=template&id=22395265&scoped=true&"
import script from "./CircleIcon.vue?vue&type=script&lang=js&"
export * from "./CircleIcon.vue?vue&type=script&lang=js&"
import style0 from "./CircleIcon.vue?vue&type=style&index=0&id=22395265&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22395265",
  null
  
)

export default component.exports